import { useCustomToast } from '@elkaso-app/web-design';
import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import http from 'apis/config/vendor-http-service';
import { useGetKasoSuppliersApi } from 'apis/suppliers/use-get-kaso-suppliers-api';
import type { AxiosError } from 'axios';
import type { UseMutationOptions, UseMutationResult } from 'react-query';

const endpoint = 'map-supplier';
export const updateMapSupplierEndpointIdentifier = endpoint;

type TData = Record<string, any>;
type TError = AxiosError;

export type TVariables = {
  supplierId: string;
  body: {
    vendorSupplierId: string;
  };
};

type Options = Omit<UseMutationOptions<TData, TError, TVariables, unknown>, 'mutationFn'>;
type ReturnType = UseMutationResult<TData, TError, TVariables>;

export function useUpdateMapSupplierApi(options?: Options): ReturnType {
  const { refetch: refetchKasoSuppliers } = useGetKasoSuppliersApi({ enabled: false });
  const toast = useCustomToast();

  const mutationFn = async ({ supplierId, body }: TVariables) => {
    try {
      const { data } = await http.patch(endpoint + `/${supplierId}`, body);

      // re-fetch suppliers list
      refetchKasoSuppliers();

      toast({
        description: 'Supplier have been mapped successfully',
        status: 'success',
      });

      return data;
    } catch (error: any) {
      if (!error.response.status || !error.response.data.message) throw error;

      toast({
        description: error.response.data.message,
        status: 'error',
      });

      throw error;
    }
  };

  return useMutationWrapper(mutationFn, { mutationKey: endpoint, ...options });
}
